<div *ngIf="!viewInvoice" class="row no-gutters">
  <div *ngIf="invoices && invoices.length > 0 else noInvoice"
    class="col-12 mt-3 table-responsive no-gutter hide-x-scroll">
    <table class="table table-striped tbl-scrollable">
      <thead class="thead-light cursor-pointer">
        <tr>
          <th width="15%" scope="col">Invoice No</th>
          <th width="25%" scope="col">Account</th>
          <th width="15%" scope="col">Amount <span
              *ngIf="invoices && invoices.length > 0">({{invoices[0].invoiceSummary.currency}})</span></th>
          <th width="15%" scope="col" (click)="onSortByDateClick(columns[3])">Invoice Date&nbsp;&nbsp;<span
              *ngIf="tableSelectedSortOptions[0] == columns[3]"><i *ngIf="tableSelectedSortOptions[1] == sortType[1]"
                class="fa fa-arrow-up" aria-hidden="true"></i><i *ngIf="tableSelectedSortOptions[1] == sortType[0]"
                class="fa fa-arrow-down" aria-hidden="true"></i></span></th>
          <!-- <th width="15%" scope="col" (click)="onSortByDateClick(columns[4])">Due Date&nbsp;&nbsp;<span
            *ngIf="tableSelectedSortOptions[0] == columns[4]"><i *ngIf="tableSelectedSortOptions[1] == sortType[1]" class="fa fa-arrow-up"
              aria-hidden="true"></i><i *ngIf="tableSelectedSortOptions[1] == sortType[0]" class="fa fa-arrow-down"
              aria-hidden="true"></i></span></th> -->
          <th width="15%" scope="col">Due Date</th>
          <th width="15%" class="text-right" scope="col">Status</th>
        </tr>
      </thead>
      <tbody class="max-height-57">
        <tr class="pointer" *ngFor="let invoice of invoices; let i = index" (click)="onInvoiceSelected(invoice)">
          <td width="15%">{{invoice.invoiceNumber}}</td>
          <td width="25%">{{invoice.customerInfo.accountInfo.name}}</td>
          <td width="15%">{{invoice.invoiceSummary.total | number : '1.2-2'}}</td>
          <td width="15%">{{invoice.invoiceDate | date: 'MM/dd/yyyy': 'Z'}}</td>
          <td width="15%">{{invoice.invoiceSummary.dueDate | date: 'MM/dd/yyyy': 'Z'}}</td>
          <td width="15%" class="text-right">
            <span>{{invoice.invoiceStatus | customText}}</span><br>
            <span
              *ngIf="invoice.invoiceStatus != invoiceStatusList[2] && invoice.paymentStatus && invoice.paymentStatus=='PROCESSING'"><small>(Payment
                Processing)</small></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #noInvoice>
    <div class="col-12 text-center" style="margin-top: 10%;">
      <h3 class="text-muted">No Invoice available for the account.</h3>
    </div>
  </ng-template>
</div>

<div *ngIf="viewInvoice" class="row mt-2 no-gutters">
  <div class="col-sm-12 card bg-light p-2 mt-3">
    <div class="row">
      <div class="col-sm-6 col-12 align-self-center">
        <div class="text-secondary font13-400 lh-35"><span class="font13-600">Billing
            Period:&nbsp;</span>{{selectedInvoice.invoiceSummary.billingPeriod.startDate | date: 'MM/dd/yyyy' : 'Z'}}-{{selectedInvoice.invoiceSummary.billingPeriod.endDate | date: 'MM/dd/yyyy' : 'Z'}}
        </div>
      </div>
      <!--NOTE : Pay now and invoice transcation commented for staging url. To be uncommented for QA url-->
      <div *ngIf="showPayment" class="col-sm-6 col-12 text-right">
        <button
          *ngIf="selectedInvoice.paymentStatus && (selectedInvoice.paymentStatus == 'PROCESSING' || selectedInvoice.paymentStatus == 'SUCCESSFUL')"
          class="btn btn-primary border btn-193" data-toggle="modal" data-target="#transactionDetailModal"
          data-backdrop="static" data-keyboard="false" (click)="transctionDetailComponent.getTransactions()">Invoice
          Transactions</button>
        <button *ngIf="showPayNowButton()" class="btn btn-primary border btn-122" (click)="goToPayment()">Pay
          Now</button> <br>
        <label *ngIf="showPayNowButton() && showAutoPaymentMessage" class="mt-1"><span
            class="text-muted font13-400">Your payment is set to be automatically paid on
            {{getAutoPaymentDate() | date: 'MM/dd/yyyy' : 'Z'}}.</span></label>
      </div>
    </div>
  </div>
  <div class="col-12 card mt-3">
    <app-invoice [invoice]="selectedInvoice"></app-invoice>
  </div>
  <div class="col-12 pt-2 p-0 pb-4 text-right" *ngIf="selectedInvoice">
    <button *ngIf="selectedInvoice && selectedInvoice.invoiceStatus != invoiceStatusList[0]"
      (click)="generatePdf.generatePdf()" class="btn btn-primary ml-3 border"
      [ngClass]="showPayNowButton() ? 'btn-122' :'btn-193'">Print as PDF</button>
  </div>
  <app-invoice-pdf [invoice]="selectedInvoice" #generatePdf></app-invoice-pdf>
</div>

<saved-payment-instruments [invoice]="selectedInvoice" [accountPaymentSetting]="accountPaymentSetting"
  (paymentStatusEmitter)="onPaymentStatusReceived($event)"></saved-payment-instruments>
<ng-container *ngIf="selectedInvoice">
  <app-payment-options [invoice]="selectedInvoice" [accountPaymentSetting]="accountPaymentSetting"
    (paymentStatusEmitter)="onPaymentStatusReceived($event)" (backClickEmitter)="onPaymentOptionBackClick()">
  </app-payment-options>
  <transaction-detail [invoice]="selectedInvoice" #transctionDetailComponent></transaction-detail>
</ng-container>

<!-- Confirmation Model for Auto Pay -->
<div class="modal fade" id="autoPayModal" tabindex="-1" role="dialog" aria-hidden="true">
  <!-- modal-sm -->
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="confirmTitle">Auto Payment</h5>
        <button id="closeAutoPayModal" type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="cancelAutoPayment();">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body fix-height-20">
        <div class="row">
          <div class="col-12 mt-3">Payment successfully submitted for processing.</div>
          <div class="col-12 mt-3">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="autoPaymentConfimation"
                (change)="onAutoPaymentConfimation()" [checked]="false">
              <label class="custom-control-label padding-top-2" for="autoPaymentConfimation">Set it up for Auto Payment</label>
            </div>
          </div>
        </div>  
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-80" (click)="confirmAutoPayment();">DONE</button>
      </div>
    </div>
  </div>
</div>
<button type="button" class="btn btn-primary" id="openAutoPayModal" [hidden]="true" data-toggle="modal"
  data-target="#autoPayModal" data-backdrop="static" data-keyboard="false">Hidden Btn</button>


<!-- Confirmation Message -->
<div class="modal fade" id="confimationMessageModal" tabindex="-1" role="dialog" aria-hidden="true">
  <!-- modal-sm -->
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="confirmTitle">Auto Payment</h5>
        <button id="closeConfimationMessageModal" type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="cancelAutoPayment();">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body fix-height-20 d-flex justify-content-center">
        <div class="align-self-center text-center">{{confirmationMessage}}</div>
      </div>
    </div>
  </div>
</div>
<button type="button" class="btn btn-primary" id="openConfimationMessageModal" [hidden]="true" data-toggle="modal"
  data-target="#confimationMessageModal" data-backdrop="static" data-keyboard="false">Hidden Btn</button>